import { formatDKAddress } from '@debbie/common/dist/addresses/adressevaelger.js';
import { EBoksRecipientType, } from '@debbie/common/dist/interactions/eboks.js';
import { useDKAddress } from '@debbie/cortex/dist/addresses/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import AlertTriangle from '../Icons/AlertTriangle.js';
const latestFailedDelivery = (attempts) => {
    if (attempts == null || attempts.length === 0) {
        return null;
    }
    const latest = attempts.reduce((a, b) => moment(a.timestamp).valueOf() >= moment(b.timestamp).valueOf() ? a : b);
    return !latest.success ? latest : null;
};
const describeAddress = (address) => [address.address, [address.zipcode, address.city].filter(Boolean).join(' ')]
    .filter((part) => part != null && part.length > 0)
    .join(', ');
const UserDeliverability = (props) => {
    const lang = useSelector((s) => s.lang);
    const { deliverability } = props.details;
    const eboksFailure = latestFailedDelivery(deliverability?.eboks);
    const failedAddress = useDKAddress(eboksFailure?.recipient.type === EBoksRecipientType.AddressId
        ? eboksFailure.recipient.addressId
        : null);
    const describeEboksRecipient = (recipient) => {
        if (recipient.type === EBoksRecipientType.KVHX ||
            recipient.type === EBoksRecipientType.AddressId) {
            const name = [recipient.firstName, recipient.lastName]
                .filter((part) => part != null && part.length > 0)
                .join(' ');
            const parts = [
                name.length > 0 ? name : null,
                recipient.type === EBoksRecipientType.KVHX &&
                    recipient.kvhx != null &&
                    recipient.kvhx.length > 0
                    ? `KVHX: ${recipient.kvhx}`
                    : null,
                recipient.type === EBoksRecipientType.AddressId &&
                    h.hasData(failedAddress) &&
                    failedAddress.data !== null
                    ? formatDKAddress(failedAddress.data)
                    : null,
            ].filter((part) => part != null);
            return parts.length > 0
                ? `${lang.debtorInfo.deliverabilityVia.eboksName} (${parts.join(', ')})`
                : lang.debtorInfo.deliverabilityVia.eboksName;
        }
        return `${lang.debtorInfo.deliverabilityVia.eboksRegisterId} (${recipient.centralRegisterId})`;
    };
    const letterFailure = latestFailedDelivery(deliverability?.letter);
    const eInvoiceFailure = latestFailedDelivery(deliverability?.eInvoice);
    const deliverabilityFailures = [
        eboksFailure && {
            channel: lang.debtorInfo.deliverabilityChannels.eboks,
            detail: describeEboksRecipient(eboksFailure.recipient),
            timestamp: eboksFailure.timestamp,
        },
        letterFailure && {
            channel: lang.debtorInfo.deliverabilityChannels.letter,
            detail: `${lang.debtorInfo.deliverabilityVia.letter} (${describeAddress(letterFailure.address)})`,
            timestamp: letterFailure.timestamp,
        },
        eInvoiceFailure && {
            channel: lang.debtorInfo.deliverabilityChannels.eInvoice,
            detail: `${lang.debtorInfo.deliverabilityVia.eInvoice} ${eInvoiceFailure.recipient.name}`,
            timestamp: eInvoiceFailure.timestamp,
        },
    ].filter((entry) => entry != null);
    if (deliverabilityFailures.length === 0) {
        return null;
    }
    return (React.createElement(DeliverabilityFailures, null, deliverabilityFailures.map((entry) => (React.createElement(DeliverabilityPill, { key: entry.channel, "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${entry.detail}. ${lang.debtorInfo.deliverabilityFailedAt} ${moment(entry.timestamp).format(THEME.DATE_FORMAT)}` },
        React.createElement(AlertTriangle, { size: "0.95em" }),
        React.createElement("span", null,
            lang.debtorInfo.cannotReceive,
            React.createElement("strong", null, entry.channel)))))));
};
export default UserDeliverability;
const DeliverabilityFailures = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: ${THEME.GRID_SPACING}px 0;
`;
const DeliverabilityPill = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
  color: #8a6100;
  background: #fff6df;
  border: 1px solid #ffe1a3;
  cursor: default;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: #ffeec2;
    border-color: #ffd47f;
  }

  svg {
    flex-shrink: 0;
    color: #d99e00;
  }

  strong {
    margin-left: 4px;
    font-weight: 700;
  }
`;
//# sourceMappingURL=UserDeliverability.js.map